const appName = process.env.REACT_APP_SITE_NAME;

const config = {
   name: appName,
   description: `${appName} Pacolor is a free and open platform for color inspiration with thousands of trendy hand-picked color palettes`,
   AUTHOR: {
      name: `${appName} Inc`,
      url: 'https://codecanyon.net/user/mycodebo',
   },
   SEO: {
      index: {
         title: `${appName} - Infinite and moderate color palettes`,
      },
      likes: {
         title: `${appName} - My Liked Palettes`,
      },
      about: {
         title: `${appName} - About`,
      },
      blocker_help: {
         title: `${appName} - How to Unblock an ad blocker`,
      },
   },
   ADS: {
      status: true,
      blocker_detect: true,
   },
};

export default config;
